module.exports = {
  id: 'contactForm',
  method: 'post',
  action: '/actions/futurium/forms/contact',
  cells: [
    {
      fieldType: 'input',
      modifier: 'half',
      name: 'title',
      label: 'Title',
      placeholder: 'Title'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'firstName',
      label: 'First name',
      placeholder: 'First name',
      autocomplete: 'given-name',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'lastName',
      label: 'Last name',
      placeholder: 'Last name',
      autocomplete: 'family-name',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'email',
      type: 'email',
      label: 'E-Mail',
      placeholder: 'E-Mail',
      autocomplete: 'email',
      required: true
    },
    {
      fieldType: 'textarea',
      name: 'comments',
      label: 'Comments',
      placeholder: 'Comments'
    }
  ],
  submitText: 'Send'
};
